import React from 'react';
import axios from "axios";
import { useState } from "react"
import { Button } from 'react-bootstrap';


    const LedLights = () => {
        const [name, setName] = useState('')
        const [email, setEmail] = useState('')
        const [number, setNumber] = useState('')
        const [lightbulb, setLightbulb] = useState('')
        const [tubelight, setTubelight] = useState('')
        const [downlightround, setDownlightround] = useState('')
        const [downlightsquare, setDownlightsquare] = useState('')
        const [quantity, setQuantity] = useState('')
        const [message1, setMessage1] = useState('')
        // const [cpassword, setCpassword] = useState('')
      
        const [statusCode, setStatusCode] = useState('')
        const [message, setMessage] = useState('')
      
      
      
        const API_PATH = 'http://amosta.com/reactJs/LEDinsert.php';
        function axios2() {
      
          axios({
            method: 'post',
            url: API_PATH,
            headers: {
              'content-type': 'application/json'
      
            },
            data: {
                "name": name,
                "email": email,
                "number": number,
                 "lightbulb":lightbulb,
                "tubelight":tubelight,
                "downlightround":downlightround,
                "downlightsquare":downlightsquare,
                "quantity":quantity,
                "message1":message1
      
            }
          })
            .then(result => {
              if (result.data.statusCode === 200) {
                setStatusCode(result.data.statusCode)
                setMessage(result.data.message)
                window.location.reload(false)
              } else {
                setStatusCode(result.data.statusCode)
                setMessage(result.data.message)
              }
              console.log(result);
            })
            .catch(error => {
              console.log(error)
            });
        }
      
    return (
        <div>
            <div className="carousel slide" data-bs-ride="carousel">
                <div className="carousel-inner">
                    <div className="carousel-item active">
                        <img src="assets/images/Lights -Banner.jpg" className="d-none d-md-block w-100 img-fluid" alt="..." />
                        <img src="assets/images/Lights -Banner 2.jpg" className="d-block d-md-none w-100 img-fluid"
                            alt="..." />
                    </div>
                </div>
            </div>
            <div className="bg-light p-3">
                <div className="container mt-5">
                    <h2 className='text-center p-3'>Various types of LED Lights</h2>

                    <div className="border p-5 bg-white shadow rounded">
                        <div className="row">
                            <div className="col-sm-12 col-md-8">
                                <ul>
                                    <li><p>Concealed Light Round Cool White</p></li>
                                    <li><p>Down Light Round Cool White</p></li>
                                    <li><p>Down Light Square Cool White</p></li>
                                </ul>
                            </div>
                            <div className="col-sm-12 col-md-4">
                                <ul>
                                    <li><p>LED Bulb</p></li>
                                    <li><p>Tube Light</p></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container mt-5">
                <h1 className="text-center p-3">Various LED Lights</h1>
                <div className="containes mt-5">
                    <div className="row">
                        <div className="col-sm-12 col-md-4 mt-3">
                            <div className="card shadow text-center led-card">
                                <div className="card-head ">
                                    <img style={{ height: '300px' }} className='w-100 img-fluid border rounded bg-dark lights-css p-2' src="assets/images/Amosta Bulb.png" alt="" />
                                </div>
                                <div className="card-body d-flex flex-column justify-content-end">
                                    <h4>LED Bulb</h4>
                                    <p className="">Code - <span className="text-muted">LB-9W-CW</span></p>
                                    <Button className='w-100 p-2' variant='success'>Know More</Button>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-4 mt-3">
                            <div className="card shadow text-center led-card">
                                <div className="card-head ">
                                    <img style={{ height: '300px' }} className='w-100 img-fluid border rounded bg-dark lights-css p-2' src="assets/images/Tube light pic.png" alt="" />
                                </div>
                                <div className="card-body d-flex flex-column justify-content-end">
                                    <h4>Tubelight</h4>
                                    <p className="">Code - <span className="text-muted">TL-20W-CW</span></p>
                                    <Button className='w-100 p-2' variant='success'>Know More</Button>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-4 mt-3">
                            <div className="card shadow text-center led-card">
                                <div className="card-head ">
                                    <img style={{ height: '300px' }} className='w-100 img-fluid border rounded bg-dark lights-css p-2' src="assets/images/Round light.png" alt="" />
                                </div>
                                <div className="card-body d-flex flex-column justify-content-end">
                                    <h4 className=''>Concealed Light Round Cool White</h4>
                                    <p className="">Code - <span className="text-muted">CL-6WRD-CW</span></p>
                                    <Button className='w-100 p-2' variant='success'>Know More</Button>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-4 mt-3">
                            <div className="card shadow text-center led-card">
                                <div className="card-head ">
                                    <img style={{ height: '300px' }} className='w-100 img-fluid border rounded bg-dark lights-css p-2' src="assets/images/down light cool white product.png" alt="" />
                                </div>
                                <div className="card-body d-flex flex-column justify-content-end">
                                    <h4>Down Light Round Cool White</h4>
                                    <p className="">Code - <span className="text-muted">CL-6WRD-CW</span></p>
                                    <Button className='w-100 p-2' variant='success'>Know More</Button>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-4 mt-3">
                            <div className="card shadow text-center led-card">
                                <div className="card-head ">
                                    <img style={{ height: '300px' }} className='w-100 img-fluid border rounded bg-dark lights-css p-2' src="assets/images/down light square 7.png" alt="" />
                                </div>
                                <div className="card-body d-flex flex-column justify-content-end">
                                    <h4>Down Light Square Cool White</h4>
                                    <p className="">Code - <span className="text-muted">PL-6WSQ-CW</span></p>
                                    <Button className='w-100 p-2' variant='success'>Know More</Button>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-4 mt-3">
                            <div className="card shadow text-center led-card">
                                <div className="card-head ">
                                    <img style={{ height: '300px' }} className='w-100 img-fluid border rounded bg-dark lights-css p-2' src="assets/images/down light cool white 5.png" alt="" />
                                </div>
                                <div className="card-body d-flex flex-column justify-content-end">
                                    <h4>Down Light Round Cool White</h4>
                                    <p className="">Code - <span className="text-muted">PL-12WRD-CW</span></p>
                                    <Button className='w-100 p-2' variant='success'>Know More</Button>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-4 mt-3">
                            <div className="card shadow text-center led-card">
                                <div className="card-head ">
                                    <img style={{ height: '300px' }} className='w-100 img-fluid border rounded bg-dark lights-css p-2' src="assets/images/down light square 3.png" alt="" />
                                </div>
                                <div className="card-body d-flex flex-column justify-content-end">
                                    <h4>Down Light Square Cool White</h4>
                                    <p className="">Code - <span className="text-muted">PL-12WSQ-CW</span></p>
                                    <Button className='w-100 p-2' variant='success'>Know More</Button>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-4 mt-3">
                            <div className="card shadow text-center led-card">
                                <div className="card-head ">
                                    <img style={{ height: '300px' }} className='w-100 img-fluid border rounded bg-dark lights-css p-2' src="assets/images/down light 6.png" alt="" />
                                </div>
                                <div className="card-body d-flex flex-column justify-content-end">
                                    <h4>Down Light Round Cool White</h4>
                                    <p className="">Code - <span className="text-muted">PL-18WRD-CW</span></p>
                                    <Button className='w-100 p-2' variant='success'>Know More</Button>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-4 mt-3">
                            <div className="card shadow text-center led-card">
                                <div className="card-head ">
                                    <img style={{ height: '300px' }} className='w-100 img-fluid border rounded bg-dark lights-css p-2' src="assets/images/down light square 4.png" alt="" />
                                </div>
                                <div className="card-body d-flex flex-column justify-content-end">
                                    <h4>Down Light Square Cool white</h4>
                                    <p className="">Code - <span className="text-muted">PL-18WSQ-CW</span></p>
                                    <Button className='w-100 p-2' variant='success'>Know More</Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="bg-light p-3 mt-5">
                <div className="container">
                    <h2 className="text-center">
                        Get In Touch
                    </h2>
                    <p className='text-center'>Get in touch if you are interested in our products</p>
                    <div className="container">
                        <div className="border bg-white rounded shadow">
                            <div className="p-5">
                                <div className="mb-3">
                                    <label htmlFor="name">Full Name:</label>
                                    <input type="text" name="name" id="name" className='form-control' placeholder='Enter your Full Name' autoComplete='off' onChange={(e) => setName(e.target.value)} required />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="mobile">Mobile Number:</label>
                                    <input type="tel" maxLength='10' className='form-control' name='number' id='mobile' placeholder='Enter your Mobile number' autoComplete='off' onChange={(e) => setNumber(e.target.value)} required />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="email">Email ID:</label>
                                    <input type="email" className='form-control' name='email' id='email' placeholder='Enter your Email ID:' autoComplete='off' onChange={(e) => setEmail(e.target.value)} required />
                                </div>
                                <div className="mb-3">
                                    <p>Select the product you are interested in:</p>
                                    <div className="row">
                                        <div className="col-sm-12 col-md-4">
                                            <input type="checkbox" name='lightbulb' id='lightbulb' onChange={(e) => setLightbulb(e.target.value)} />
                                            <label className='ms-2' htmlFor="lightbulb">Light Bulb</label>
                                        </div>
                                        <div className="col-sm-12 col-md-4">
                                            <input type="checkbox" name='tubelight' id='tubelight' onChange={(e) => setTubelight(e.target.value)} />
                                            <label className='ms-2' htmlFor="tubelight">Tubelight</label>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-12 col-md-4">
                                            <input type="checkbox" name='downlightround' id='downlightround' onChange={(e) => setDownlightround(e.target.value)} />
                                            <label className='ms-2' htmlFor="downlightround">Down Light Round</label>
                                        </div>
                                        <div className="col-sm-12 col-md-4">
                                            <input type="checkbox" name='downlightsquare' id='downlightsquare' onChange={(e) => setDownlightsquare(e.target.value)} />
                                            <label className='ms-2' htmlFor="downlightsquare">Down Light Square</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group mb-3">
                                    <label htmlFor="quantity">Quantity:</label>
                                    <input type='number' name="quantity" id="quantity" required autoComplete='off' min='1' className='form-control' placeholder='Enter Quantity' onChange={(e) => setQuantity(e.target.value)} />
                                </div>
                                <div className="form-group mb-3">
                                    <label htmlFor="textarea">Message:</label>
                                    <textarea name="message1" id="message1" className='form-control' style={{height: '150px'}} placeholder='Type a message' onChange={(e) => setMessage1(e.target.value)}></textarea>
                                </div>
                                <div className="mb-3">
                                    <Button variant='success' type='submit' onClick={axios2} className='w-100 p-2'>Submit</Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default  LedLights;